import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { catchError, map, Observable, timeout } from 'rxjs';
import { ApiClientConfig } from '../api-client.config';
import { UploadFileResponse } from '../storage/api.storage.models';
import {
  AddSocialGiftBody,
  AddSocialGiftResponse,
  GetAllSocialGiftParams,
  GetAllSocialGiftResponse,
  GetSocialGiftResponse
} from './api.soical-gift.model';

export class SocialGiftApi {
  private apiUrl = environment.API_URL;
  private SOCIAL_GIF = '/social-gift/social-gift';

  constructor(
    public readonly http: HttpClient,
    public config: ApiClientConfig
  ) {}

  getAllSocialGift(params: GetAllSocialGiftParams): Observable<GetAllSocialGiftResponse> {
    const { filters, pageNum, pageSize, sort } = params;

    return this.http
      .get<GetAllSocialGiftResponse>(
        `${this.apiUrl}${this.SOCIAL_GIF}/search?filters=${encodeURIComponent(filters)}`,
        {
          params: { pageNum, pageSize, sort }
        }
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map(res => {
          return res;
        }),
        catchError(err => {
          throw err.error;
        })
      );
  }

  getSocialGift(giftId: string): Observable<GetSocialGiftResponse> {
    return this.http.get<GetSocialGiftResponse>(`${this.apiUrl}${this.SOCIAL_GIF}/${giftId}`).pipe(
      timeout(this.config.responseTimeout),
      map(res => {
        return res;
      }),
      catchError(err => {
        throw err.error;
      })
    );
  }

  addSocialGift(body: AddSocialGiftBody): Observable<AddSocialGiftResponse> {
    return this.http.post<AddSocialGiftResponse>(`${this.apiUrl}${this.SOCIAL_GIF}`, body).pipe(
      timeout(this.config.responseTimeout),
      map(res => {
        return res;
      }),
      catchError(err => {
        throw err.error;
      })
    );
  }

  editSocialGift(body: AddSocialGiftBody, giftId: string): Observable<AddSocialGiftResponse> {
    return this.http
      .put<AddSocialGiftResponse>(`${this.apiUrl}${this.SOCIAL_GIF}/${giftId}`, body)
      .pipe(
        timeout(this.config.responseTimeout),
        map(res => {
          return res;
        }),
        catchError(err => {
          throw err.error;
        })
      );
  }

  removeSocialGift(giftId: string): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}${this.SOCIAL_GIF}/${giftId}`).pipe(
      timeout(this.config.responseTimeout),
      map(res => {
        return res;
      }),
      catchError(err => {
        throw err.error;
      })
    );
  }

  uploadJsonFile(formData: FormData, description: string): Observable<UploadFileResponse> {
    return this.http
      .post<any>(`${this.apiUrl}${this.SOCIAL_GIF}/files/upload`, formData, {
        params: { description }
      })
      .pipe(
        timeout(this.config.responseTimeout),
        map(res => {
          return res;
        }),
        catchError(err => {
          throw err.error;
        })
      );
  }
}
